import {React,useEffect} from 'react'
import { Link } from 'react-router-dom'
import { useSelector,useDispatch } from 'react-redux'
import { fetchAbout } from "../../../features/aboutSlice/aboutSlice";


const AboutTopic = () => {
    const about = useSelector((state) => state.about);
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(fetchAbout());
    }, []);
  return (
    <div>


         {/* category */}
         <div className="xsm:top-[5rem]  overflow-scroll sticky max-w top-[4rem] z-10 flex justify-center bg-white lg:top-[7.5rem]">
           
           <div className="font-Yatra  items-center z-50 flex justify-center gap-2 rounded-lg px-2 py-4 sm:!gap-6 text-white">
            
           <Link to="/about/company-startup" className="about-button">
                  कर्यालय स्थापना परिचया
                </Link>
                <Link to="/about/company-goals" className="about-button">
                  लछ्य तथा उद्यश्यहरु
                </Link>
                <Link to="/about/manager-details" className="about-button">
                  प्रबन्द निर्देसको भनाइ
                </Link>
                <Link to="/about/employee-details" className="about-button">
                  कर्मचारिको बिबरन
                </Link>
                <Link to="/about/registration-certificate" className="about-button">
                  दर्ता प्रमाण पत्र
                </Link>
           
           </div>
         </div>
    </div>
  )
}

export default AboutTopic